import { render } from "./Healthcare.vue?vue&type=template&id=1f08ddcb&scoped=true&ts=true"
import script from "./Healthcare.vue?vue&type=script&lang=ts"
export * from "./Healthcare.vue?vue&type=script&lang=ts"

import "./Healthcare.vue?vue&type=style&index=0&id=1f08ddcb&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f08ddcb"]])

export default __exports__